<template>
  <v-card class="session__container">
    <ChooseLanguage :positionAbsolute="true" />
    <div class="session__content">
      <div>
        <v-img
          src="@/static/brand_logo.svg"
          class="mx-auto session__logo"
          aspect-ratio
          width="300"
        >
        </v-img>
      </div>
      <h2 class="mb-3 text-center session__title">
        {{ $t("message.common.forgotPassword") }}
      </h2>
      <template v-if="!resetMessage">
        <p class="text-center session__description">
          {{ $t("message.session.forgot.description") }}.
        </p>
        <v-form v-model="valid" @submit.prevent="onFormSubmitted" class="mb-8">
          <v-text-field
            :label="emailLabel"
            v-model="email"
            v-validate="'required|email'"
            :error-messages="errors.collect(emailLabel)"
            :data-vv-name="emailLabel"
            required
          ></v-text-field>
          <v-btn
            large
            :loading="loading"
            color="primary"
            class="mb-4"
            block
            type="submit"
          >
            {{ this.$t("message.common.sendEmail") }}
          </v-btn>
        </v-form>
      </template>
      <template>
        <p class="text-center session__description">{{ resetMessage }}</p>
      </template>
      <div class="text-center">
        <router-link :to="{ name: 'session-login' }">{{
          $t("message.common.backToSignIn")
        }}</router-link>
      </div>
    </div>
  </v-card>
</template>

<script>
import ChooseLanguage from "@/components/AppBar/ChooseLanguage.vue";
import serviceHandler from "@/helpers/handlers/service";
import userService from "@/services/users";

export default {
  name: "SessionForgotPassword",
  data() {
    return {
      loading: false,
      email: "",
      emailLabel: this.$t("message.common.email"),
      valid: false,
      resetMessage: ""
    };
  },
  components: { ChooseLanguage },
  methods: {
    async onFormSubmitted() {
      this.loading = true;

      if (this.valid) {
        const resetMessage = await serviceHandler(
          userService.resetPassword({ email: this.email })
        );

        if (resetMessage) {
          this.resetMessage = resetMessage.detail;
        }

        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
